export function formatPrice(number?: number | null, fixed?: number): string {
  if (!number) return "0"
  const fixedValue = fixed ? fixed <= 0 ? 0 : fixed : 2;
  return (number / 100).toFixed(fixedValue).replace('.', ',');
}